// Prints a window. This is in its own file as it can be mocked more effectively.
const printWindow = (w?: Window | null) => w?.print();

export default printWindow;
